const state = {
    parent_1: {
        name: '',
        phone: '',
        phone_type: '',
        alt_phone: '',
        alt_phone_type: '',
        contact_order: '',
        gender: '',
        relationship: '',
        relationship_other: '',
        address: '',
        employer: '',
        email: ''
    },
    parent_2: {
        name: '',
        phone: '',
        phone_type: '',
        alt_phone: '',
        alt_phone_type: '',
        contact_order: '',
        gender: '',
        relationship: '',
        relationship_other: '',
        address: '',
        employer: '',
        email: ''
    },
    parent_3: {
        name: '',
        phone: '',
        phone_type: '',
        alt_phone: '',
        alt_phone_type: '',
        contact_order: '',
        gender: '',
        relationship: '',
        relationship_other: '',
        address: '',
        employer: '',
        email: ''
    },
    parent_4: {
        name: '',
        phone: '',
        phone_type: '',
        alt_phone: '',
        alt_phone_type: '',
        contact_order: '',
        gender: '',
        relationship: '',
        relationship_other: '',
        address: '',
        employer: '',
        email: ''
    }
}

const mutations = {
    setName(state, payload) { state['parent_' + payload.num].name = payload.value },
    setPhone(state, payload) { state['parent_' + payload.num].phone = payload.value },
    setPhoneType(state, payload) { state['parent_' + payload.num].phone_type = payload.value },
    setAltPhone(state, payload) { state['parent_' + payload.num].alt_phone = payload.value },
    setAltPhoneType(state, payload) { state['parent_' + payload.num].alt_phone_type = payload.value },
    setContactOrder(state, payload) { state['parent_' + payload.num].contact_order = payload.value },
    setGender(state, payload) { state['parent_' + payload.num].gender = payload.value },
    setRelationship(state, payload) { state['parent_' + payload.num].relationship = payload.value },
    setRelationshipOther(state, payload) { state['parent_' + payload.num].relationship_other = payload.value },
    setAddress(state, payload) { state['parent_' + payload.num].address = payload.value },
    setEmployer(state, payload) { state['parent_' + payload.num].employer = payload.value },
    setEmail(state, payload) { state['parent_' + payload.num].email = payload.value },
}

export default {
    namespaced: true,
    state,
    mutations
}
